import React from 'react';
import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  useTheme
} from '@mui/material';
import type { ShowView } from '@stores/calibrationUIStore';

export type { ShowView };

type ShowViewFilterProps = {
  showView: ShowView;
  onShowViewChange: (view: ShowView) => void;
};

export const ShowViewFilter: React.FC<ShowViewFilterProps> = ({
  showView,
  onShowViewChange
}) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        Show:
      </Typography>
      <ToggleButtonGroup
        value={showView}
        exclusive
        onChange={(_, newView) => {
          if (newView !== null) {
            onShowViewChange(newView);
          }
        }}
        size="small"
        sx={{
          '& .MuiToggleButton-root': {
            padding: '4px 12px',
            fontSize: '0.75rem',
            '&.Mui-selected': {
              '&[value="asFound"]': {
                backgroundColor: isDarkMode
                  ? 'rgba(33, 150, 243, 0.3)'
                  : 'rgba(33, 150, 243, 1)',
                color: isDarkMode ? 'rgba(33, 150, 243, 1)' : 'white',
                '&:hover': {
                  backgroundColor: isDarkMode
                    ? 'rgba(33, 150, 243, 0.4)'
                    : 'rgba(33, 150, 243, 0.8)'
                }
              },
              '&[value="all"]': {
                backgroundColor: isDarkMode
                  ? 'rgba(144, 202, 249, 0.3)'
                  : 'info.main',
                color: isDarkMode ? 'rgba(144, 202, 249, 1)' : 'white',
                '&:hover': {
                  backgroundColor: isDarkMode
                    ? 'rgba(144, 202, 249, 0.4)'
                    : 'info.dark'
                }
              },
              '&[value="asLeft"]': {
                backgroundColor: isDarkMode
                  ? 'rgba(76, 175, 80, 0.3)'
                  : 'rgba(76, 175, 80, 1)',
                color: isDarkMode ? 'rgba(76, 175, 80, 1)' : 'white',
                '&:hover': {
                  backgroundColor: isDarkMode
                    ? 'rgba(76, 175, 80, 0.4)'
                    : 'rgba(76, 175, 80, 0.8)'
                }
              }
            }
          }
        }}
      >
        <ToggleButton value="asFound">As Found</ToggleButton>
        <ToggleButton value="all">All</ToggleButton>
        <ToggleButton value="asLeft">As Left</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};
